import { render, staticRenderFns } from "./AccountDeleted.vue?vue&type=template&id=3f5b295a&scoped=true"
import script from "./AccountDeleted.vue?vue&type=script&lang=ts"
export * from "./AccountDeleted.vue?vue&type=script&lang=ts"
import style0 from "./AccountDeleted.vue?vue&type=style&index=0&id=3f5b295a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5b295a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f5b295a')) {
      api.createRecord('3f5b295a', component.options)
    } else {
      api.reload('3f5b295a', component.options)
    }
    module.hot.accept("./AccountDeleted.vue?vue&type=template&id=3f5b295a&scoped=true", function () {
      api.rerender('3f5b295a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statics/AccountDeleted.vue"
export default component.exports